// CustomButton.js
import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import PulseLoader from 'react-spinners/PulseLoader';

const CustomButton = ({
  text,
  variant,
  onClick,
  className,
  fullwidth = false,
  state1,
  state2,
  state3,
  loading,
  size,
  disabled,

  editPath,
  type = 'button', // Default type is "button", can be "submit" or "reset"
  link = '', // Optional navigate link
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link, {
        state: {
          form1Value: state1,
          form2Value: state2,
          form3Value: state3 || ' ',
        },
      }); // If there's a link, navigate to it
    }
    if (onClick) {
      onClick(); // If a custom onClick is provided, execute it
    }
  };

  return (
    <Button
      variant={variant}
      className={className}
      type={type}
      fullWidth={fullwidth}
      size={size}
      disabled={loading || disabled}
      onClick={handleClick}
    >
      {loading ? <PulseLoader color={'#fff'} size={8} /> : text}
    </Button>
  );
};

export default CustomButton;
